import React, { useRef, useState } from 'react';

//*MUI
import { Box, Checkbox, Divider, Modal } from '@mui/material';

//*files
import cssClasses from './AddAgreementConfirmation.module.css';
import Close from '../../Components/Icons/Close';
import Button from '../../Subcomponents/Button';
import DropDown from '../../Subcomponents/DropDown';
import CustomInput from '../../Subcomponents/CustomInput';
import DateComponent from '../../Subcomponents/DateComponent';
import CustomRadio from '../../Subcomponents/CustomRadio';
import Datagrid from '../../Subcomponents/Datagrid';
import { debounce } from 'lodash';
import { getPAN_cardDetails } from '../../Services/SurepassApi';
import { errorTost } from '../../Services/Toast';

const style = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '85%',
  width: 'Fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

export default function AddAgreementConfirmation({ open, handleClose }) {
  const [AgreementDetails, setAgreementDetails] = useState({
    UnitType: '',
    UnitNo: '',
    NoOfApplicants: '',
    PowerOfAttorney: '',
    email1:"",
    email2:"",
    email3:"",
    panNumber1: "",
    panNumber2: "",
    panNumber3: "",
    isPanValid1: false,
    isPanValid2: false,
    isPanValid3: false,
    Occupation1:"",
    Occupation2:"",
    Occupation3:"",
    Date1:"",
    Date2:'',
    Date3:'',
    prefix1:"Mr",
    prefix2:"Mr",
    prefix3:"Mr",
    AttorneyDob:'',
    AttorneyPanNumber:'',
  });


  //*pan-Validation-1
  const [panNumber1, setPanNumber1] = useState("");
  const [verified1, setVerified1] = useState(false);
  const [isLoadingPan1, setIsLoadingPan1] = useState(false);
  const [VerifyPan1, setVerifyPan1] = useState(true);
  const [panName1, setPanName1] = useState("");
  const [panObject1, setPanObject1] = useState(null);

  //*pan-Validation-2
  const [panNumber2, setPanNumber2] = useState("");
  const [verified2, setVerified2] = useState(false);
  const [isLoadingPan2, setIsLoadingPan2] = useState(false);
  const [VerifyPan2, setVerifyPan2] = useState(true);
  const [panName2, setPanName2] = useState("");
  const [panObject2, setPanObject2] = useState(null);


  //*pan-Validation-3
  const [panNumber3, setPanNumber3] = useState("");
  const [verified3, setVerified3] = useState(false);
  const [isLoadingPan3, setIsLoadingPan3] = useState(false);
  const [VerifyPan3, setVerifyPan3] = useState(true);
  const [panName3, setPanName3] = useState("");
  const [panObject3, setPanObject3] = useState(null);

   //*pan-Validation-Attorney
   const [panNumberAttorney, setPanNumberAttorney] = useState("");
   const [verifiedAttorney, setVerifiedAttorney] = useState(false);
   const [isLoadingPanAttorney, setIsLoadingPanAttorney] = useState(false);
   const [VerifyPanAttorney, setVerifyPanAttorney] = useState(true);
   const [panNameAttorney, setPanNameAttorney] = useState("");
   const [panObjectAttorney, setPanObjectAttorney] = useState(null);


  //*Doc-verification-1
  const [verifiedKycDoc1, setVerifiedKycDoc1] = useState({
    docNumber1: "",
    docType1: "",
    docName1: "",
    docObject1: null,
  });

   //*Doc-verification-2
  const [verifiedKycDoc2, setVerifiedKycDoc2] = useState({
    docNumber2: "",
    docType2: "",
    docName2: "",
    docObject2: null,
  });

   //*Doc-verification-3
  const [verifiedKycDoc3, setVerifiedKycDoc3] = useState({
    docNumber3: "",
    docType3: "",
    docName3: "",
    docObject3: null,
  });

   //*Doc-verification-Attorney
   const [verifiedKycDocAttorney, setVerifiedKycDocAttorney] = useState({
    docNumberAttorney: "",
    docTypeAttorney: "",
    docNameAttorney: "",
    docObjectAttorney: null,
  });

  const [HelperText, setHelperText] = useState({
    panNumber1: "",
    panNumber2: "",
    panNumber3: "",
    email1:"",
    email2:"",
    email3:"",
    Date1:"",
    Date2:"",
    Date3:"",
    prefix1:"",
    AttorneyDob:'',

  });

  const PriceData = [
    { id: '1', SrNo: '1', Date: '', ChequeNo: '' },
    // { id: '2', SrNo: '2', Date: '', ChequeNo: '' },
  ];

  const ProjectColumns = [
    {
      field: 'SrNo',
      headerName: 'Sr.No',
      width: 70,
      renderCell: (params) => {
        return (
          <Box>
            <Checkbox
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: 18,
                },
              }}
              // checked={selectedAllotments.includes(params.row.booking_id) ? true : false}
              // onChange={(e) => {
              //                     if (e.target.checked) {
              //                         setSelectedAllotments((pre) => {
              //                             pre.push(params.row.booking_id)
              //                             return [...pre]
              //                         })
              //                     } else {
              //                         setSelectedAllotments((pre) => {
              //                             pre.splice(pre.findIndex((e) => e === params.row.booking_id), 1)
              //                             return [...pre]
              //                         })
              //                     }
              //                 }}
            />{' '}
          </Box>
        );
      },
    },
    {
      field: 'Date',
      headerName: 'Date',
      width: 280,
      renderCell: (params) => {
        return (
          <DateComponent
            // value={selectDates[0].value}
            minDate={'1 Jan'}
            // onChangeDate={(value) => {
            //   console.log(value);
            //   setSelectedDate('notNull');
            //   setSelectDates((pre) => {
            //     pre[0].value = value;
            //     return { ...pre };
            //   });
            //   setHelperText((pre) => {
            //     pre.endDate = '';
            //     return { ...pre };
            //   });
            // }}
            // helperText={helperText.startDate}
          ></DateComponent>
        );
      },
    },
    {
      field: 'ChequeNo',
      headerName: 'Cheque No/UTR No',
      width: 250,
      renderCell: (params) => {
        return (
          <Box>
            <CustomInput
              placeholder={'Cheque No/UTR No'}
              // value={panNumber}
              // handleChange={(newValue) => {
              // }}
              // helperText={HelperText.panNumber}
              // isLoading={isLoadingPan}
              // greenTick={HelperText.isPanValid}
            />
          </Box>
        );
      },
    },
    {
      field: 'BankName',
      headerName: 'Bank Name',
      width: 250,
      renderCell: (params) => {
        return (
          <Box>
            <CustomInput
              placeholder={'Bank Name'}
              // value={panNumber}
              // handleChange={(newValue) => {
              // }}
              // helperText={HelperText.panNumber}
              // isLoading={isLoadingPan}
              // greenTick={HelperText.isPanValid}
            />
          </Box>
        );
      },
    },
    {
      field: 'Amount',
      headerName: 'Amount',
      width: 250,
      renderCell: (params) => {
        return (
          <Box>
            <CustomInput
              placeholder={'Amount'}
              // value={panNumber}
              // handleChange={(newValue) => {
              // }}
              // helperText={HelperText.panNumber}
              // isLoading={isLoadingPan}
              // greenTick={HelperText.isPanValid}
            />
          </Box>
        );
      },
    },
    {
      field: 'Consideration',
      headerName: 'Consideration & GST',
      width: 250,
      renderCell: (params) => {
        return (
          <Box>
            <CustomInput
              placeholder={'Consideration & GST'}
              // value={panNumber}
              // handleChange={(newValue) => {
              // }}
              // helperText={HelperText.panNumber}
              // isLoading={isLoadingPan}
              // greenTick={HelperText.isPanValid}
            />
          </Box>
        );
      },
    },
    {
      field: 'Action',
      headerName: 'Action',
      width: 280,
      renderCell: (params) => {
        return (
          <Button
            style={{
              color: '#155EEF',
              backgroundColor: '#FFF',
              border: '1px solid #155EEF',
              fontSize: '1.4rem',
              lineHeight: '2rem',
              padding: '0.5rem 0.6rem',
            }}
            //   disable={verified === false}
            btnName={'Save & Add Row(if Required)'}
            // clicked={OnSubmit}
          />
        );
      },
    },
  ];

  const PAN_CardCheck1 = useRef(
    debounce((e, _apiToken) => {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan1(false);
          console.log("Pan-Card-Data", res.data);
          if (res?.data?.message_code === "success") {
            setVerifyPan1(false);
            setHelperText((pre) => {
              pre.isPanValid1 = true;
              pre.panNumber1 = "";
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setPanName1(
              res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
            );
            setPanObject1(res.data.data);
            setVerifiedKycDoc1((pre) => {
              pre.docName1 = res.data.data.full_name
                .toUpperCase()
                .replace(/\s\s+/g, " ");
              pre.docNumber1 = e;
              pre.docType1 = "PanCard";
              pre.docObject1 = res.data;
              return { ...pre };
            });
          } else {
            setIsLoadingPan1(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPan1(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanName1("");
            let pre = { ...HelperText };
            pre.panNumber1 = err?.response?.data?.message;
            pre.isPanValid1 = false;

            setHelperText({ ...pre });
          } else {
            console.log("error-pan", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  const PAN_CardCheck2 = useRef(
    debounce((e, _apiToken) => {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan2(false);
          console.log("Pan-Card-Data", res.data);
          if (res?.data?.message_code === "success") {
            setVerifyPan2(false);
            setHelperText((pre) => {
              pre.isPanValid2 = true;
              pre.panNumber2 = "";
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setPanName2(
              res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
            );
            setPanObject2(res.data.data);
            setVerifiedKycDoc2((pre) => {
              pre.docName2 = res.data.data.full_name
                .toUpperCase()
                .replace(/\s\s+/g, " ");
              pre.docNumber2 = e;
              pre.docType2 = "PanCard";
              pre.docObject2 = res.data;
              return { ...pre };
            });
          } else {
            setIsLoadingPan2(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPan2(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanName2("");
            let pre = { ...HelperText };
            pre.panNumber2 = err?.response?.data?.message;
            pre.isPanValid2 = false;

            setHelperText({ ...pre });
          } else {
            console.log("error-pan", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  const PAN_CardCheck3 = useRef(
    debounce((e, _apiToken) => {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan3(false);
          console.log("Pan-Card-Data", res.data);
          if (res?.data?.message_code === "success") {
            setVerifyPan3(false);
            setHelperText((pre) => {
              pre.isPanValid3 = true;
              pre.panNumber3 = "";
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setPanName3(
              res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
            );
            setPanObject3(res.data.data);
            setVerifiedKycDoc3((pre) => {
              pre.docName3 = res.data.data.full_name
                .toUpperCase()
                .replace(/\s\s+/g, " ");
              pre.docNumber3 = e;
              pre.docType3 = "PanCard";
              pre.docObject3 = res.data;
              return { ...pre };
            });
          } else {
            setIsLoadingPan3(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPan3(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanName3("");
            let pre = { ...HelperText };
            pre.panNumber3 = err?.response?.data?.message;
            pre.isPanValid3 = false;

            setHelperText({ ...pre });
          } else {
            console.log("error-pan", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  const PAN_CardCheckAttorney = useRef(
    debounce((e, _apiToken) => {
      // console.log(e);
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPanAttorney(false);
          console.log("Pan-Card-Data", res.data);
          if (res?.data?.message_code === "success") {
            setVerifyPanAttorney(false);
            setHelperText((pre) => {
              pre.isPanValidAttorney = true;
              pre.panNumberAttorney = "";
              return { ...pre };
            });
            console.log("res.data.data.full_name", res.data.data.full_name);
            setPanName3(
              res.data.data.full_name.toUpperCase().replace(/\s\s+/g, " ")
            );
            setPanObjectAttorney(res.data.data);
            setVerifiedKycDocAttorney((pre) => {
              pre.docNameAttorney = res.data.data.full_name
                .toUpperCase()
                .replace(/\s\s+/g, " ");
              pre.docNumberAttorney = e;
              pre.docTypeAttorney = "PanCard";
              pre.docObjectAttorney = res.data;
              return { ...pre };
            });
          } else {
            setIsLoadingPanAttorney(false);
            // setPAN_cardIsVerified(false);
          }
        })
        .catch((err) => {
          setIsLoadingPanAttorney(false);
          console.log("err", err);
          // console.log(err?.response?.data);
          if (err?.response?.data?.message) {
            setPanNameAttorney("");
            let pre = { ...HelperText };
            pre.panNumberAttorney = err?.response?.data?.message;
            pre.isPanValidAttorney = false;

            setHelperText({ ...pre });
          } else {
            console.log("error-pan", err.response.data.message_code);
            errorTost(err.response.data.message_code);
          }
        });
    }, 800)
  ).current;

  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box>
              <Box className={cssClasses.flexCol1}>
                <Box className={cssClasses.HeaderTitle} mt={1}>
                  AGREEMENT CONFIRMATION FORM
                </Box>
                <Box className={cssClasses.InputTitle1}>
                  (FILL DETAILS IN CAPITAL LETTERS)
                </Box>
              </Box>
              {/* <Box
                ml={'auto'}
                mt={1}
                onClick={CancelClose}
                style={{ cursor: 'pointer' }}
              >
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box> */}
            </Box>
          </Box>
          <Box width={'100%'} height={'80%'} overflow={'auto'}>
            <Box margin={'1.5rem 3.2rem'}>
              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle} mt={1}>
                  Project & Building Name
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={'Choose Your Project'}
                    list={['Building1', 'Building2']}
                    //   selectedValue={SiteVisitDetails.fosName}
                    //   onChangeSelect={(value) => {
                    //     console.log(value);
                    //     setSiteVisitDetails((pre) => {
                    //       pre.fosName = value;
                    //       return { ...pre };
                    //     });
                    //     let selectedFos;
                    //     selectedFos = FosData.filter(({ name }) => value === name);
                    //     console.log(selectedFos);
                    //     setSiteVisitDetails((pre) => {
                    //       pre.fosId = selectedFos[0].fosId;
                    //       return { ...pre };
                    //     });
                    //   }}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle} mt={1}>
                  Unit Type
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={'Choose Your Unit Type'}
                    list={['2BHK', '3BHK']}
                    selectedValue={AgreementDetails.UnitType}
                    onChangeSelect={(value) => {
                      console.log(value);
                      setAgreementDetails((pre) => {
                        pre.UnitType = value;
                        return { ...pre };
                      });
                    }}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle} mt={1}>
                  Unit No
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    placeholder={'Insert Your Unit No'}
                    value={AgreementDetails.UnitNo}
                    handleChange={(newValue) => {
                      console.log(newValue);
                      setAgreementDetails((pre) => {
                        pre.UnitNo = newValue;
                        return { ...pre };
                      });
                    }}
                    // helperText={HelperText.panNumber}
                    // isLoading={isLoadingPan}
                    // greenTick={HelperText.isPanValid}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    How Many Applicant
                    <span className={cssClasses.Star}>*</span>
                  </Box>
                  <Box className={cssClasses.widthBox1}>
                    <DropDown
                      placeHolder={'Choose Applicant No'}
                      list={['1', '2', '3']}
                      selectedValue={AgreementDetails.NoOfApplicants}
                      onChangeSelect={(value) => {
                        console.log(value);
                        setAgreementDetails((pre) => {
                          pre.NoOfApplicants = value;
                          return { ...pre };
                        });
                      }}
                    />
                  </Box>
                </Box>

                <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Power of Attorney if Applicable
                    <span className={cssClasses.Star}>*</span>
                  </Box>
                  <Box className={cssClasses.widthBox1}>
                    <DropDown
                      placeHolder={'Choose Yes/No'}
                      list={['Yes', 'No']}
                      selectedValue={AgreementDetails.PowerOfAttorney}
                      onChangeSelect={(value) => {
                        console.log(value);
                        setAgreementDetails((pre) => {
                          pre.PowerOfAttorney = value;
                          return { ...pre };
                        });
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {(AgreementDetails.NoOfApplicants === '1' ||
                AgreementDetails.NoOfApplicants === '2' ||
                AgreementDetails.NoOfApplicants === '3') && (
                <>
                  <Divider />
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      1st Applicant Name
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox3}>
                      <DropDown
                        placeHolder={'Prefix'}
                        list={['Mr', 'Mrs', 'Miss']}
                        selectedValue={AgreementDetails.prefix1}
                          onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.prefix1 = value;
                              return { ...pre };
                            });
                           
                          }}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'First Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Middle Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Last Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Date of Birth
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DateComponent
                        value={AgreementDetails.Date1}
                        minDate={'1 Jan'}
                        onChangeDate={(value) => {
                          console.log(value);
                          // setSelectedDate('notNull');
                          setAgreementDetails((pre) => {
                            pre.Date1 = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.Date1 = '';
                            return { ...pre };
                          });
                        }}
                        helperText={HelperText.Date1}
                      ></DateComponent>
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Occupation
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={'Choose Your Occupation'}
                        list={['Doctor', 'IT' , 'Farming' , 'CA']}
                        selectedValue={AgreementDetails.Occupation1}
                        onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.Occupation1 = value;
                              return { ...pre };
                            });
                          
                        }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      PAN NO
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Enter PAN Number'}
                        value={panNumber1}
                        handleChange={(newValue) => {
                          setVerified1(false);
                          setVerifyPan1(true);
                          newValue = newValue.trim();
                          newValue = newValue.toUpperCase();
                          var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                          if (!regex.test(newValue)) {
                            HelperText.isPanValid1 = false;
                            setPanName1('');
                            HelperText.panNumber1 =
                              'Please enter Valid PAN number.';
                          } else {
                            HelperText.panNumber1 = 'verifying...';
                            if (newValue.length === 10) {
                              setIsLoadingPan1(true);
                              PAN_CardCheck1(newValue.toUpperCase());
                            }
                          }
                          if (newValue.length === 0 ) {
                            // && kycOption === false
                            setVerified1(true);
                            HelperText.panNumber1 = '';
                          }
                          if (newValue.length <= 10) {
                            setPanNumber1(newValue);
                          }
                        }}
                        helperText={HelperText.panNumber1}
                        isLoading={isLoadingPan1}
                        greenTick={HelperText.isPanValid1}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Mob No
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Insert Your Mobile No'}
                        inputType={'number'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      1st Applicant Email
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'example@example.com'}
                        value={AgreementDetails.email1}
                        handleChange={(newValue) => {
                          newValue = newValue.trimStart();
                          const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!newValue.trim()) {
                            HelperText.email1 = "Please Enter Email Id";
                          } else if (!newValue.match(emailIDCond)) {
                            HelperText.email1 =
                              "Please Enter Email in Proper Format";
                          } else {
                            // checkPersonExistsInTable(newValue);
                            HelperText.email1 = "";
                          }
                          if (newValue.length <= 50) {
                            setAgreementDetails((pre) => {
                              pre.email1 = newValue;
                              return Object.assign({}, pre);
                            });
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}

              {(AgreementDetails.NoOfApplicants === '2' ||
                AgreementDetails.NoOfApplicants === '3') && (
                <>
                  <Divider />
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      2nd Applicant Name
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox3}>
                    <DropDown
                        placeHolder={'Prefix'}
                        list={['Mr', 'Mrs', 'Miss']}
                        selectedValue={AgreementDetails.prefix2}
                          onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.prefix2 = value;
                              return { ...pre };
                            });
                           
                          }}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'First Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Middle Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Last Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Date of Birth
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DateComponent
                        value={AgreementDetails.Date2}
                        minDate={'1 Jan'}
                        onChangeDate={(value) => {
                          console.log(value);
                          // setSelectedDate('notNull');
                          setAgreementDetails((pre) => {
                            pre.Date2 = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.Date2 = '';
                            return { ...pre };
                          });
                        }}
                        helperText={HelperText.Date2}
                      ></DateComponent>
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Occupation
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={'Choose Your Occupation'}
                        list={['Doctor', 'IT' , 'Farming' , 'CA']}
                        selectedValue={AgreementDetails.Occupation2}
                        onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.Occupation2 = value;
                              return { ...pre };
                            });
                        }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      PAN NO
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Enter PAN Number'}
                        value={panNumber2}
                        handleChange={(newValue) => {
                          setVerified2(false);
                          setVerifyPan2(true);
                          newValue = newValue.trim();
                          newValue = newValue.toUpperCase();
                          var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                          if (!regex.test(newValue)) {
                            HelperText.isPanValid2 = false;
                            setPanName1('');
                            HelperText.panNumber2 =
                              'Please enter Valid PAN number.';
                          } else {
                            HelperText.panNumber2 = 'verifying...';
                            if (newValue.length === 10) {
                              setIsLoadingPan2(true);
                              PAN_CardCheck2(newValue.toUpperCase());
                            }
                          }
                          if (newValue.length === 0 ) {
                            // && kycOption === false
                            setVerified2(true);
                            HelperText.panNumber2 = '';
                          }
                          if (newValue.length <= 10) {
                            setPanNumber2(newValue);
                          }
                        }}
                        helperText={HelperText.panNumber2}
                        isLoading={isLoadingPan2}
                        greenTick={HelperText.isPanValid2}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Mob No
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Insert Your Mobile No'}
                        inputType={'number'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      2nd Applicant Email
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'example@example.com'}
                        value={AgreementDetails.email2}
                        handleChange={(newValue) => {
                          newValue = newValue.trimStart();
                          const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!newValue.trim()) {
                            HelperText.email2 = "Please Enter Email Id";
                          } else if (!newValue.match(emailIDCond)) {
                            HelperText.email2 =
                              "Please Enter Email in Proper Format";
                          } else {
                            // checkPersonExistsInTable(newValue);
                            HelperText.email2 = "";
                          }
                          if (newValue.length <= 50) {
                            setAgreementDetails((pre) => {
                              pre.email2 = newValue;
                              return Object.assign({}, pre);
                            });
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}

              {AgreementDetails.NoOfApplicants === '3' && (
                <>
                  <Divider />
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      3rd Applicant Name
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox3}>
                    <DropDown
                        placeHolder={'Prefix'}
                        list={['Mr', 'Mrs', 'Miss']}
                        selectedValue={AgreementDetails.prefix3}
                          onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.prefix3 = value;
                              return { ...pre };
                            });
                           
                          }}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'First Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Middle Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>

                    <Box className={cssClasses.widthBox2}>
                      <CustomInput
                        placeholder={'Last Name'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Date of Birth
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DateComponent
                        value={AgreementDetails.Date3}
                        minDate={'1 Jan'}
                        onChangeDate={(value) => {
                          console.log(value);
                          // setSelectedDate('notNull');
                          setAgreementDetails((pre) => {
                            pre.Date3 = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.Date2 = '';
                            return { ...pre };
                          });
                        }}
                        helperText={HelperText.Date3}
                      ></DateComponent>
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Occupation
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={'Choose Your Occupation'}
                        list={['Doctor', 'IT' , 'Farming' , 'CA']}
                        selectedValue={AgreementDetails.Occupation3}
                        onChangeSelect={(value) => {
                         console.log(value);
                         setAgreementDetails((pre) => {
                           pre.Occupation3 = value;
                           return { ...pre };
                         });
                          
                        }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      PAN NO
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Enter PAN Number'}
                        value={panNumber3}
                        handleChange={(newValue) => {
                          setVerified3(false);
                          setVerifyPan3(true);
                          newValue = newValue.trim();
                          newValue = newValue.toUpperCase();
                          var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                          if (!regex.test(newValue)) {
                            HelperText.isPanValid3 = false;
                            setPanName3('');
                            HelperText.panNumber3 =
                              'Please enter Valid PAN number.';
                          } else {
                            HelperText.panNumber3 = 'verifying...';
                            if (newValue.length === 10) {
                              setIsLoadingPan3(true);
                              PAN_CardCheck3(newValue.toUpperCase());
                            }
                          }
                          if (newValue.length === 0 ) {
                            // && kycOption === false
                            setVerified3(true);
                            HelperText.panNumber3 = '';
                          }
                          if (newValue.length <= 10) {
                            setPanNumber3(newValue);
                          }
                        }}
                        helperText={HelperText.panNumber3}
                        isLoading={isLoadingPan3}
                        greenTick={HelperText.isPanValid3}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      Mob No
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'Insert Your Mobile No'}
                        inputType={'number'}
                        // value={panNumber}
                        // handleChange={(newValue) => {
                        // }}
                        // helperText={HelperText.panNumber}
                        // isLoading={isLoadingPan}
                        // greenTick={HelperText.isPanValid}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      3rd Applicant Email
                      {/* <span className={cssClasses.Star}>*</span> */}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomInput
                        placeholder={'example@example.com'}
                        value={AgreementDetails.email3}
                        handleChange={(newValue) => {
                          newValue = newValue.trimStart();
                          const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (!newValue.trim()) {
                            HelperText.email3 = "Please Enter Email Id";
                          } else if (!newValue.match(emailIDCond)) {
                            HelperText.email3 =
                              "Please Enter Email in Proper Format";
                          } else {
                            // checkPersonExistsInTable(newValue);
                            HelperText.email3 = "";
                          }
                          if (newValue.length <= 50) {
                            setAgreementDetails((pre) => {
                              pre.email3 = newValue;
                              return Object.assign({}, pre);
                            });
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}

              <Divider/>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle} mt={1}>
                  Indian Address
                  {/* <span className={cssClasses.Star}>*</span> */}
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    placeholder={'Street Address'}
                    // value={panNumber}
                    // handleChange={(newValue) => {
                    // }}
                    // helperText={HelperText.panNumber}
                    // isLoading={isLoadingPan}
                    // greenTick={HelperText.isPanValid}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}></Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    placeholder={'Street Address Line 2'}
                    // value={panNumber}
                    // handleChange={(newValue) => {
                    // }}
                    // helperText={HelperText.panNumber}
                    // isLoading={isLoadingPan}
                    // greenTick={HelperText.isPanValid}
                  />
                </Box>
              </Box>

              <Box className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}></Box>
                <Box display={'flex'} flexDirection={'row'} width={'33rem'}>
                  <Box mr={'1rem'}>
                    <CustomInput
                      placeholder={'City'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                  <Box>
                    <CustomInput
                      placeholder={'State / Province'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}></Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    placeholder={'Postal / Zip Code'}
                    inputType={'number'}
                    // value={panNumber}
                    // handleChange={(newValue) => {
                    // }}
                    // helperText={HelperText.panNumber}
                    // isLoading={isLoadingPan}
                    // greenTick={HelperText.isPanValid}
                  />
                </Box>
              </Box>

              <Divider />

              <Box className={cssClasses.InputTitle1}>
                POWER OF ATTORNEY HOLDER DETAIL(IF ANY* only applicable who is
                not available for registration.(NEED REGISTERED POA COPY))
                {/* <span className={cssClasses.Star}>*</span> */}
              </Box>

              <Box margin={'2rem 6rem'}>
                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Attorney Holder Name:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={''}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Date of Birth:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                  <DateComponent
                        value={AgreementDetails.AttorneyDob}
                        minDate={'1 Jan'}
                        onChangeDate={(value) => {
                          console.log(value);
                          // setSelectedDate('notNull');
                          setAgreementDetails((pre) => {
                            pre.AttorneyDob = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.AttorneyDob = '';
                            return { ...pre };
                          });
                        }}
                        helperText={HelperText.AttorneyDob}
                      ></DateComponent>
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Occupation:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                      <DropDown
                        placeHolder={'Choose Your Occupation'}
                        list={['Doctor', 'IT' , 'Farming' , 'CA']}
                        selectedValue={AgreementDetails.Occupation3}
                        onChangeSelect={(value) => {
                            console.log(value);
                            setAgreementDetails((pre) => {
                              pre.Occupation3 = value;
                              return { ...pre };
                            });
                          
                        }}
                      />
                    </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Mob No:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={'Enter Mobile Number'}
                      inputType={'number'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    PAN NO:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={'Enter PAN Number'}
                      value={panNumberAttorney}
                      handleChange={(newValue) => {
                        setVerifiedAttorney(false);
                        setVerifyPanAttorney(true);
                        newValue = newValue.trim();
                        newValue = newValue.toUpperCase();
                        var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                        if (!regex.test(newValue)) {
                          HelperText.isPanValidAttorney = false;
                          setPanNameAttorney('');
                          HelperText.panNumberAttorney =
                            'Please enter Valid PAN number.';
                        } else {
                          HelperText.panNumberAttorney = 'verifying...';
                          if (newValue.length === 10) {
                            setIsLoadingPanAttorney(true);
                            PAN_CardCheckAttorney(newValue.toUpperCase());
                          }
                        }
                        if (newValue.length === 0 ) {
                          // && kycOption === false
                          setVerifiedAttorney(true);
                          HelperText.panNumberAttorney = '';
                        }
                        if (newValue.length <= 10) {
                          setPanNumberAttorney(newValue);
                        }
                      }}
                      helperText={HelperText.panNumberAttorney}
                      isLoading={isLoadingPanAttorney}
                      greenTick={HelperText.isPanValidAttorney}
                    />
                  </Box>
                </Box>
              </Box>

              <Divider />
              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}>
                  Do you wish to opt VJ Finserv Services in Future?(For more
                  information please refer VJ Parivaar Welcome Booklet Page No
                  07)
                  {/* <span className={cssClasses.Star}>*</span> */}
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomRadio
                    optionList={['Yes', 'No']}
                    // value={props.tokenData.isPriorityPass ? "Priority Pass" :"None"}
                    // onChangeValue={(e) => {
                    //   if(e === "None") {
                    //     props.setTokenData({
                    //       ...props.tokenData,
                    //       isPriorityPass: false,
                    //     });
                    //   } else if(e === "Priority Pass") {
                    //     props.setTokenData({
                    //       ...props.tokenData,
                    //       isPriorityPass: true,
                    //     });
                    //   }
                    // }}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle} mt={1}>
                  Type of Finance
                  {/* <span className={cssClasses.Star}>*</span> */}
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={'Choose Your Finance Option'}
                    list={['1', '2']}
                    //   selectedValue={SiteVisitDetails.fosName}
                    //   onChangeSelect={(value) => {
                    //     console.log(value);
                    //     setSiteVisitDetails((pre) => {
                    //       pre.fosName = value;
                    //       return { ...pre };
                    //     });
                    //     let selectedFos;
                    //     selectedFos = FosData.filter(({ name }) => value === name);
                    //     console.log(selectedFos);
                    //     setSiteVisitDetails((pre) => {
                    //       pre.fosId = selectedFos[0].fosId;
                    //       return { ...pre };
                    //     });
                    //   }}
                  />
                </Box>
              </Box>

              <Divider/>

              <Box className={cssClasses.InputTitle1}>
                Home / Commercial Loan Detail(Bank)
              </Box>

              <Box margin={'2rem 6rem'}>
                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Bank Name:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={''}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Loan Amount:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={'Enter the Loan Amount'}
                      inputType={'number'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Bank Person Name:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={'Enter the Name'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>

                <Box className={cssClasses.flexRow} mb={1}>
                  <Box className={cssClasses.InputTitle} mt={1}>
                    Bank Person Mob No:
                    {/* <span className={cssClasses.Star}>*</span> */}
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <CustomInput
                      placeholder={'Enter Mobile Number'}
                      inputType={'number'}
                      // value={panNumber}
                      // handleChange={(newValue) => {
                      // }}
                      // helperText={HelperText.panNumber}
                      // isLoading={isLoadingPan}
                      // greenTick={HelperText.isPanValid}
                    />
                  </Box>
                </Box>
              </Box>

              {/* <Divider /> */}
              {(AgreementDetails.NoOfApplicants === '1' ||
                AgreementDetails.NoOfApplicants === '2' ||
                AgreementDetails.NoOfApplicants === '3') && (
                <>
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      1st Applicant PAN Card Copy
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      1st Applicant PAN Card Copy (Front & Back)
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>
                </>
              )}

                <Divider/>
              {(AgreementDetails.NoOfApplicants === '2' ||
                AgreementDetails.NoOfApplicants === '3') && (
                <>
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      2nd Applicant PAN Card Copy
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      2nd Applicant PAN Card Copy (Front & Back)
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>
                </>
              )}

              <Divider/>
              {AgreementDetails.NoOfApplicants === '3' && (
                <>
                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      3rd Applicant PAN Card Copy
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>

                  <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                    <Box className={cssClasses.InputTitle} mt={1}>
                      3rd Applicant PAN Card Copy (Front & Back)
                      <span className={cssClasses.Star}>*</span>
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <input
                        type='file'
                        accept='.pdf'
                        id='imgupload'
                        name=''
                        // onChange={async (e) => {
                        //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                        //   console.log("e.target.files[0]" , e.target.files[0])
                        // }}
                      />
                    </Box>
                  </Box>
                </>
              )}

              <Divider/>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}>
                  Marriage Certificate (if PAN of wife is in her Maiden Name)
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <input
                    type='file'
                    accept='.pdf'
                    id='imgupload'
                    name=''
                    // onChange={async (e) => {
                    //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                    //   console.log("e.target.files[0]" , e.target.files[0])
                    // }}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}>
                  Home Loan Sanction Letter(if Any)
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <input
                    type='file'
                    accept='.pdf'
                    id='imgupload'
                    name=''
                    // onChange={async (e) => {
                    //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                    //   console.log("e.target.files[0]" , e.target.files[0])
                    // }}
                  />
                </Box>
              </Box>

              <Box margin={'2rem 0'} className={cssClasses.flexRow}>
                <Box className={cssClasses.InputTitle}>
                  Power of Attorney Copy
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <input
                    type='file'
                    accept='.pdf'
                    id='imgupload'
                    name=''
                    // onChange={async (e) => {
                    //   setUser({...user , crmUserDocUrl: e.target.files[0]})
                    //   console.log("e.target.files[0]" , e.target.files[0])
                    // }}
                  />
                </Box>
              </Box>

              <Divider />

              <Box className={cssClasses.InputTitle1}>
                PAYMENT TRANSACTION DETAIL TILL DATE (Booking amounts and New
                payments as per cost sheet)
                <span className={cssClasses.Star}>*</span>
              </Box>

              <Box height={'40rem'} display={'flex'} flexDirection={'column'}>
                <Box style={{ height: '40rem', width: '100%' }}>
                  <Box style={{ width: '100%', height: '100%' }}>
                    <Box className={cssClasses.GridWrapper}>
                      <Datagrid
                        rows={PriceData}
                        columns={ProjectColumns}
                        hideFooter={false}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Divider/>

              <Box className={cssClasses.InputTitle1}>Terms and Conditions</Box>
              <Box className={cssClasses.InputTitle1}>
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 18,
                    },
                  }}
                  // checked={selectedAllotments.includes(params.row.booking_id) ? true : false}
                  // onChange={(e) => {
                  //                     if (e.target.checked) {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.push(params.row.booking_id)
                  //                             return [...pre]
                  //                         })
                  //                     } else {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.splice(pre.findIndex((e) => e === params.row.booking_id), 1)
                  //                             return [...pre]
                  //                         })
                  //                     }
                  //                 }}
                />{' '}
                SELF FUNDING - I would like to put on record that I am not
                availing any finance for the said flat from any Bank/Financial
                Institution and I am purchasing the said Flat through
                self-funding. I assure and confirm and consent that if in any
                case I am unable to pay timely payment towards the consideration
                of the said Flat I shall liable to pay interest on the same and
                further you shall also have due right to cancel the booking of
                the said Flat after giving reasonable opportunity of 15(fifteen
                days).<span className={cssClasses.Star}>*</span>
              </Box>

              <Box className={cssClasses.InputTitle1}>
                Terms and Conditions<span className={cssClasses.Star}>*</span>
              </Box>
              <Box className={cssClasses.InputTitle1}>
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 18,
                    },
                  }}
                  // checked={selectedAllotments.includes(params.row.booking_id) ? true : false}
                  // onChange={(e) => {
                  //                     if (e.target.checked) {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.push(params.row.booking_id)
                  //                             return [...pre]
                  //                         })
                  //                     } else {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.splice(pre.findIndex((e) => e === params.row.booking_id), 1)
                  //                             return [...pre]
                  //                         })
                  //                     }
                  //                 }}
                />{' '}
                OPTING HOME LOAN - I would like to put on record that I am
                availing finance for the said Flat of from Bank/Financial
                Institution and balance I am paying through self-funding. I
                assure and confirm and consent that if in any case i am unable
                to pay timely payment towards the consideration of the said Flat
                I shall be liable to pay interest on the same and further you
                shall also have due right to cancel the booking of the said Flat
                after giving reasonable opportunity of 15(fifteen days).
                <span className={cssClasses.Star}>*</span>
              </Box>

              <Box className={cssClasses.InputTitle1}>
                Terms and Conditions <span className={cssClasses.Star}>*</span>
              </Box>
              <Box className={cssClasses.InputTitle1}>
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 18,
                    },
                  }}
                  // checked={selectedAllotments.includes(params.row.booking_id) ? true : false}
                  // onChange={(e) => {
                  //                     if (e.target.checked) {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.push(params.row.booking_id)
                  //                             return [...pre]
                  //                         })
                  //                     } else {
                  //                         setSelectedAllotments((pre) => {
                  //                             pre.splice(pre.findIndex((e) => e === params.row.booking_id), 1)
                  //                             return [...pre]
                  //                         })
                  //                     }
                  //                 }}
                />{' '}
                I/We have read all the terms and conditions of the application
                form for Allotment of unit and agreed to abide by the same. Also
                checked and agreed on the final cost sheet shared with me/us
                through an email. Further, i/we hereby authorized Vilas Javdekar
                Developers , to pay Stamp duty and Registration Challan / ESBTR
                to Govt. Of Maharashtra on my behalf based on our provided
                information. In any event of breach of contract/cancellation, I
                shall be responsible to bear the losses and shall be solely
                responsible for any refund and follow up with Govt. if
                Applicable.
                <span className={cssClasses.Star}>*</span>
              </Box>
            </Box>
          </Box>
          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    color: '#344054',
                    backgroundColor: '#ffffff',
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Preview'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#ffffff',
                    backgroundColor: '#155EEF',
                  }}
                  //   disable={verified === false}
                  btnName={'Reset'}
                  // clicked={OnSubmit}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
